<template>
    <div class="remindWrapper">
        <div class="remind_header">
          <el-row>
            <el-col :span="8"><div class="grid-content bg-purple-dark" style="font-size:1.33rem;color:#303133">{{$t('remind.header')}}</div></el-col>
            </el-col>
          </el-row>
        </div>

        <div class="remind_mid">
          <div class="message_ctn"> 
            <el-row>
              <el-col :span="12"><div class="demo-shadow remind_message" style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
                <p>* {{$t('remind.remind_message')}}
                <span style="color:#F56C6C">{{$t('remind.charge')}}</span></p></div>
              </el-col>

            </el-row>
          </div>

          <div class="seller_ctn">
            <el-row>
              <el-col :span="5" style="margin-top:0.67rem;padding-left:1.33rem">
                <span class="demo-shadow remind_userid">
                  <b style="color:#606266">
                    {{userId}} 
                  </b>
                </span>
                {{$t('remind.seller_back')}}
              </el-col>

              <el-col :span="3" style="font-size:18px;margin-top:7px">
                <b style="color:#606266">{{$t('remind.shopee')}}</b>
              </el-col>

              <el-col :span="5">
                  <el-select v-model="value_shopee">
                    <el-option v-for="item in shopList" :key="item.shopId" :label="item.shopName" :value="item.shopId"></el-option>
                  </el-select>
              </el-col>

              <!-- <el-button @click="demo">{{$t('other.a945')}}</el-button>  -->
              <!-- <el-col :span="3" style="font-size:18px;margin-top:7px">
                <b>LAZADA{{$t('other.a1674')}}</b>
              </el-col>

              <el-col :span="4">
                  <el-select v-model="value_LAZADA" :placeholder="$t('other.a50')">
                    <el-option v-for="item in lazadashopinfo" :key="item.sellerId" :label="item.name" :value="item.sellerId"></el-option>
                  </el-select>
              </el-col> -->


            </el-row>
            <!-- <el-button style="float: right; padding: 3px 0" type="text" @click="demo">{{$t('other.a945')}}</el-button> -->
          </div>
        </div>

        <div class="remind_main">
          
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">{{$t('remind.orderCare')}}</el-menu-item>
            <el-menu-item index="2">{{$t('remind.record')}}</el-menu-item>
          </el-menu>

        <div class="card_ctn order_ctn" v-if="activeIndex==1&&(value_shopee!=''||value_LAZADA!='')">
              
            <el-row>
              <el-col :span="7" class="el_col_ctn">
                <el-card class="box-card" style="height:22rem">
                    <el-row style="border-bottom: 3px solid #f4f4f4;height:2.66rem;">
                      <el-col :span="16" style="height:2.66rem;padding-top:0.333rem">
                        <span style="">{{$t('remind.paymentRemind')}}</span>
                      </el-col>
                      <el-col :span="8">
                        <!-- <el-button style="float: right; padding: 3px 0;" type="text" @click="dialog = true"><i class="el-icon-setting" style="font-size:20.333rem"></i></el-button>    -->
                      </el-col>
                    </el-row>
                  <div class="card_bottom" >
                    <el-row style="height:3.33rem" class="center">
                      <el-col  class="switch" >
                        <el-switch
                          v-model="paymentRemind"
                          :active-text="$t('remind.open')"
                          :inactive-text="$t('remind.close')"
                          @click.native="open(2)"
                          >
                        </el-switch>
                      </el-col>
                    </el-row>
                    <el-row class="center">
                      <b style="color:#606266">{{$t('remind.displayEffect')}}</b>
                    </el-row>

                    <el-row class="center">
                      <el-row>
                        <el-popover  
                          placement="top-start"
                          width="800"
                          trigger="click"
                          >
                            <el-row>
                              <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.succseePayOrdersNum')}}</span>
                              <el-select v-model="paymentPeriodCountType" :placeholder="$t('remind.pleaseSelect')" style="float:right;width:7rem" @change="setCountOption(2,false)">
                                <el-option
                                  v-for="item in paymentPeriod_Option"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                              <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.successSendMessage')}}</span>
                              <el-select v-model="loopTimesType" :placeholder="$t('remind.successSendMessage')" style="float:right;width:7rem" @change="setCountOption(2,false)">
                                <el-option
                                  v-for="item in loopTimes_Option"
                                  :key="item.value"
                                  :label="item.value"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                              <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.lately')}}</span>
                            </el-row>
                          <div ref="echart_paymentCount" id="echart_paymentCount" style="width:50rem;height:26.66rem" v-loading="ifSetCountOption"></div>




                            <!-- <el-button style="float:right;margin-right:3rem" @click="initialization(2)">初始化</el-button> -->
                          <el-button slot="reference" @click="setCountOption(2,true)" type="text" ><i class="el-icon-data-line" style="font-size:25px"></i></el-button>
                        </el-popover>
                      </el-row>
                    </el-row>


                    <el-row class="center">
                        <el-tag size="small">{{$t('remind.totalSend')}}:<b>{{statisic.paymentRecordTotalCount}}</b>{{$t('remind.successSendMessage')}}</el-tag>
                    </el-row>
                    <el-row class="center" style="margin-top:0.2rem">
                        <el-tag size="small" type="success">{{$t('remind.successRecive_')}}:<b>{{statisic.paymentRecordSuccessCount}}</b>{{$t('remind.strip')}}</el-tag>
                    </el-row>
                    <el-row class="center" style="margin-top:0.2rem">
                        <el-tag size="small" type="success">{{$t('remind.successPayOrder')}}:<b>{{statisic.paymentRecordPaidOrderCount}}</b>{{$t('other.a1337')}}</el-tag>
                    </el-row>
                    <el-row class="center" style="margin-top:0.2rem">
                        <el-tag size="small" type="success" >{{$t('remind.successPay')}}:<b>{{statisic.paymentRecordPaidOrderAmount}}</b>฿</el-tag>
                    </el-row> 




                    <el-row >
                      <el-button style="float: right; padding: 3px 0;margin-top:1.3rem" type="text" @click="edit($t('remind.paymentRemind'),2)">{{$t('remind.edit')}}</el-button>
                    </el-row>

                  </div>
                </el-card>


              </el-col>

              <el-col :span="7" class="el_col_ctn">
                <el-card class="box-card" style="height:22rem" >
                    <el-row style="border-bottom: 3px solid #f4f4f4;height:2.66rem;">
                      <el-col :span="8" style="height:2.66rem;padding-top:0.333rem">
                        <span style="">{{$t('remind.shipReminder')}}</span>
                      </el-col>
                      <el-col :span="8" style="height:1px">

                      </el-col>
                      <el-col :span="8">
                        <!-- <el-button style="float: right; padding: 3px 0;" type="text" @click="dialog = true"><i class="el-icon-setting" style="font-size:20.333rem"></i></el-button>    -->
                      </el-col>
                    </el-row>
                  <div class="card_bottom"  >


                    
                    <el-row style="height:3.33rem" class="center">
                      <el-col  class="switch" >
                        <el-switch
                          v-model="shipmentRemind"
                          :active-text="$t('remind.open')"
                          :inactive-text="$t('remind.close')"
                          @click.native="open(1)"
                          >
                        </el-switch>
                      </el-col>
                    </el-row>


                    <el-row class="center">
                      <b style="color:#606266">{{$t('remind.displayEffect')}}</b>
                    </el-row>

                    <el-row class="center">
                      <el-row>
                        <el-popover  
                          placement="top-start"
                          width="800"
                          trigger="click"
                          >
                          <el-row>
                            <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.sendAndSuccessSendCount')}}</span>
                            <el-select v-model="loopTimesType" :placeholder="$t('remind.pleaseSelect')" style="float:right;width:7rem" @change="setCountOption(1,false)">
                              <el-option
                                v-for="item in loopTimes_Option"
                                :key="item.value"
                                :label="item.value"
                                :value="item.value">
                              </el-option>
                            </el-select>
                            <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.lately')}}</span>
                          </el-row>
                          <div ref="echart_shipmentCount" id="echart_shipmentCount" style="width:48.4rem;height:26.66rem" v-loading="ifSetCountOption" ></div>
                          <el-button slot="reference" @click="setCountOption(1,true)" type="text" ><i class="el-icon-data-line" style="font-size:25px"></i></el-button>
                        </el-popover>
                      </el-row>
                    </el-row>

                    <el-row class="center" v-if="shipmentRemind">
                      <el-checkbox v-model="codSwitch" @change="setCodSwitch">{{$t('remind.ifOnlyRemindCod')}}</el-checkbox>
                    </el-row>
                    <el-row style="margin-top:1rem" class="center">
                        <el-tag size="small">{{$t('remind.totalSend')}}:<b>{{statisic.shipRecordTotalCount}}</b>{{$t('remind.strip')}}</el-tag>
                    </el-row>

                    <el-row style="margin-top:0.67rem" class="center">
                        <el-tag size="small" type="success">{{$t('remind.successRecive_')}}:<b>{{statisic.shipRecordSuccessCount}}</b>{{$t('remind.strip')}}</el-tag>
                    </el-row>
                    <el-row style="margin-top:1.4rem">
                      <el-button style="float: right; padding: 3px 0;margin-top:0.67rem" type="text" @click="edit($t('remind.shipReminder'),1)">{{$t('remind.edit')}}</el-button>
                    </el-row>

                  </div>
                </el-card>


              </el-col>

              <el-col :span="7" class="el_col_ctn">
                <el-card class="box-card" style="height:22rem">
                    <el-row style="border-bottom: 3px solid #f4f4f4;height:2.66rem;">
                      <el-col :span="8" style="height:2.66rem;padding-top:0.333rem">
                        <span style="">{{$t('remind.signRemind')}}</span>
                      </el-col>
                      <el-col :span="8" style="height:1px">

                      </el-col>
                      <el-col :span="8">
                        <!-- <el-button style="float: right; padding: 3px 0;" type="text" @click="dialog = true"><i class="el-icon-setting" style="font-size:20.333rem"></i></el-button>    -->
                      </el-col>
                    </el-row>
                  <div class="card_bottom" >


                    
                    <el-row style="height:3.33rem" class="center">
                      <el-col  class="switch" >
                        <el-switch
                          v-model="signRemind"
                          :active-text="$t('remind.open')"
                          :inactive-text="$t('remind.close')"
                          @click.native="open(3)"
                          >
                        </el-switch>
                      </el-col>
                    </el-row>
              
                    <el-row class="center">
                      <b style="color:#606266">{{$t('remind.displayEffect')}}</b>
                    </el-row>

                    <el-row class="center">
                      <el-row>
                        <el-popover  
                          placement="top-start"
                          width="800"
                          trigger="click"
                          style="margin-left:0.6rem">
                          <el-row>
                            <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.sendAndSuccessSendCount')}}</span>
                            <el-select v-model="loopTimesType" :placeholder="$t('remind.pleaseSelect')" style="float:right;width:7rem" @change="setCountOption(3,false)">
                              <el-option
                                v-for="item in loopTimes_Option"
                                :key="item.value"
                                :label="item.value"
                                :value="item.value">
                              </el-option>
                              </el-select>
                            <span style="float:right;font-size:16px;margin-top:0.6rem;margin-right:0.4rem">{{$t('remind.lately')}}</span>
                          </el-row>
                          <div ref="echart_signRemindCount" id="echart_signRemindCount" style="width:48.4rem;height:26.66rem" v-loading="ifSetCountOption"></div>


                          <el-button slot="reference"  @click="setCountOption(3,true)" type="text" ><i class="el-icon-data-line" style="font-size:25px"></i></el-button>
                        </el-popover>
                      </el-row>
                    </el-row>

                    <el-row  class="center">
                        <el-tag size="small">{{$t('remind.totalSend')}}:<b>{{statisic.signRecordTotalCount}}</b>{{$t('remind.strip')}}</el-tag>
                    </el-row>

                    <el-row style="margin-top:0.67rem" class="center">
                        <el-tag size="small" type="success">{{$t('remind.successRecive_')}}:<b>{{statisic.signRecordSuccessCount}}</b>{{$t('remind.strip')}}</el-tag>
                    </el-row>
                    <el-row style="margin-top:2.9rem">
                      <el-button style="float: right; padding: 3px 0;margin-top:1.3rem" type="text" @click="edit($t('remind.signRemind'),3)">{{$t('remind.edit')}}</el-button>
                    </el-row>
                  </div>
                </el-card>
              </el-col>
            </el-row>
        </div>

        <div class="card_ctn logistics_ctn center"  v-else>  
          <el-row style="width:100%">

            <el-row style="margin-bottom:1.33rem ;" >
              <el-col :span="2" class="center" style="height:2.66rem" >
                <b  style="color:#606266">{{$t('remind.remindType')}}</b>
              </el-col>
              <el-col :span="6">
                <el-radio-group v-model="radio">
                  <el-radio-button :label="$t('other.a2216')" >{{$t('remind.paymentRemind')}}</el-radio-button>
                  <el-radio-button  :label="$t('other.a2217')">{{$t('remind.shipReminder')}}</el-radio-button>
                  <el-radio-button  :label="$t('other.a2218')">{{$t('remind.signRemind')}}</el-radio-button>
                </el-radio-group>
              </el-col>
                <el-col :span="2" class="center" style="height:2.66rem">
                    <b style="color:#606266">{{$t('remind.orderId')}}</b>
                </el-col>
                <el-col :span="4">
                  <el-input
                    :placeholder="$t('remind.orderId')"
                    @change="getOrderSn()"
                    clearable
                    v-model="req_params_record.orderId">
                  </el-input>
                </el-col>
                <el-col :span="2" class="center" style="height:2.66rem">
                    <b style="color:#606266">{{$t('remind.buyerName')}}</b>
                </el-col>
                <el-col :span="4">
                  <el-input
                    :placeholder="$t('remind.buyerName')"
                    @change="getOrderSn()"
                    clearable
                    v-model="req_params_record.userName">
                  </el-input>
                </el-col>
            </el-row>



            <el-row>
              <el-table
                :data="tableData"
                style="width:100%"
                border
                >
                <el-table-column
                  prop="ordersn"
                  :label="$t('remind.orderId')"
                  >
                </el-table-column>
                <el-table-column
                  prop="buyerUserName"
                  :label="$t('remind.buyerName')"
                  >
                </el-table-column>
                <el-table-column
                  prop="noteType_"
                  :label="$t('remind.Type')"
                  >
                </el-table-column>
                <el-table-column
                  prop="chargeNumber"
                  :label="$t('remind.CountNum')"
                  >
                </el-table-column>
                <el-table-column
                  prop="integralCost"
                  :label="$t('remind.CountIntegral')"
                  >
                </el-table-column>
                <el-table-column
                  prop="deliveryResults"
                  :label="$t('remind.deliveryResult')"
                  >
                </el-table-column>
                <el-table-column
                  prop="arriveTime"
                  :label="$t('remind.arriveTime')"
                  width="250px">
                </el-table-column>
              </el-table>
            </el-row>
            <el-row style="height:3.33rem">
            </el-row>
            <el-row>
              <el-pagination
              class="page"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage1"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="offset"
              layout=" total,sizes, prev, pager, next, jumper"
              :total="recordTotal">
              </el-pagination>
          </el-row>
          </el-row>
        </div> 
        </div>



    </div>

</template>
    

    <script>
    import api from '../../api/moudles/remind'
    import { mapState, mapActions } from 'vuex'
    import test from '../../pages/remind/test.json'
	  import echarts from 'echarts'

    export default {
    data(){
    return{
        table: false,
        paymentRemind: true,
        shipmentRemind: true,
        signRemind: true,
        activeIndex:'1',
        template_name:null,
        shop_item:"1",
        value_shopee:'',
        value_LAZADA:'',
        label:'',
        fit:'',
        shopId:this.$route.params.shopId,
        value3:null,
        order_record:test.order_record,
        remindType:test.order_record[0],
        radio:this.$t('other.a2216'),
        time: [],
        shopName:null,


				req_params:{
					shopIds:null,
					storeIds:null,
					orderId:'',
					offset:15,
					logistics:null,
					page:0,
					start:null,
					end:null,
					platform:'SHOPEE',
					shopIds:JSON.parse(localStorage.getItem('userInfo')).shopeeShops.map(p => {return p.shopId}),
					storeIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
					userId:JSON.parse(localStorage.getItem('userInfo')).userId
				},

        req_params_record:{
          pageNum:1,
          pageSize:5,
          noteType:2,
        },

        queryOrderId:null,  
        currentPage1:1,
        offset:5,
        option: [{
                  value: this.$t('other.a2219'),
                  label: this.$t('other.a2219')
                },{
                  value: '10',
                  label: '10min'
                }, {
                  value: '20',
                  label: '20min'
                }, {
                  value: '30',
                  label: '30min'
                }, {
                  value: '40',
                  label: '40min'
                }, {
                  value: '50',
                  label: '50min'
                }],
                value1:null,
                value2:null,
                startTypt:1,
                endTypt:1,
//echart相关
        form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
              },
              table: false,
              loading: false,
              formLabelWidth: '80px',
              dialog: false,
              noteType:[this.$t('other.a2217'),this.$t('other.a2216'),this.$t('other.a2220')],
              tableData:null,
              startTime:null,
              endTime:null,
              statisic:{
                shipRecordTotalCount: 0,
                paymentRecordSuccessCount: 0,
                signRecordTotalCount: 0,
                shipRecordSuccessCount: 0,
                signRecordSuccessCount: 0,
                paymentRecordTotalCount: 0
              },
              recordTotal:0,
              condition:test.condition,
              codSwitch:false,
              echart_option:null,

              paymentPeriodCountType:"1hour",
              loopTimesType:"1day",


              paymentCountOption_:null,
              shipmentCountOption_:null,
              signRemindCountOption_:null,
              CountOption_:null,
              loopTimes_Option:[
                {
                value:'1day',
              },{
                value:'7day'
              },{
                value:'30day'
              },{
                value:'90day'
              },{
                value:'180day'
              }],

              paymentPeriod_Option:[{
                value:'1hour'
              },{
                value:'6hour'
              },{
                value:'12hour'
              }],

              successPayCountType:'1hour',
              ifSuccessPayCountOption:false,
              CountEchartOption:null,
              ifSetCountOption:true

    }
    
  },

    
    computed:{
        ...mapState({
            userId: state => state.shopaccess.userInfo.userId,
            lazadashopinfo: state=>state.shopaccess.lazadashopinfo,
			      shopList: state => state.shopaccess.shopInfo || '',
            amountListCount:state=>state.processed.amountListCount ,
            CountOption:state=>state.remind.CountOption,
        }),
    },


    
    watch:{

      value_shopee(newName, oldName){
        if(this.value_shopee!=''&&this.value_LAZADA!=''){
          this.value_LAZADA=''
          this.shopId=this.value_shopee
        }else if(this.value_shopee!=''&&this.value_LAZADA==''){
          this.shopId = this.value_shopee
        }
      },
     
      value_LAZADA(newName, oldName){
        if(this.value_LAZADA!=''&&this.value_shopee!=''){
          this.value_shopee=''
          this.shopId=this.value_LAZADA
        }else if(this.value_LAZADA!=''&&this.value_shopee==''){
          this.shopId = this.value_LAZADA
        }
      },

      async shopId(){
        var that = this
        var params = {
          loopTimes:25,
          period:3600,
          shopId:this.shopId
        }
        // this.getPayRemindEchart(params)
        // this.setSuccessPayCountOption()
        api.getNoteRemind({
          shopId:this.shopId
          // shopId:2152236
        }).then(res=>{
          console.log(res)
          this.paymentRemind = res.paymentRemind==1
          this.shipmentRemind = res.shipmentRemind==1
          this.signRemind = res.signRemind==1
          if(res.statisic==null){
            this.statisic = res.statisic
          }else{
            this.statisic = {shipRecordTotalCount: 0,
                paymentRecordSuccessCount: 0,
                signRecordTotalCount: 0,
                shipRecordSuccessCount: 0,
                signRecordSuccessCount: 0,
                paymentRecordTotalCount: 0
                }
          }
          console.log(res.statisic.paymentRecordTotalCount!=undefined)
          if(res.statisic.paymentRecordTotalCount!=undefined){
            this.statisic = res.statisic
          }
        })
          var queryData = this.shopList.filter(function(fp) {
            return fp.shopId == that.shopId
          })
          console.log(queryData[0].shopName)
          this.shopName = queryData[0].shopName
          this.getCodSwitch()
          // await this.getRemindSendCount(this.shopId)

      },

      radio(){
        console.log(this.radio)
        switch(this.radio){
          case this.$t('other.a2220') :
            this.req_params_record.noteType = 3
            break 
          case this.$t('other.a2216') : 
            this.req_params_record.noteType = 2
            break
          case this.$t('other.a2217') :
            this.req_params_record.noteType = 1
        }
        this.getPaymentRemindRecordBy(this.req_params_record)

      },

                




      'req_params_record.orderId':function(){
        var req_params_record =  this.req_params_record
          if(req_params_record.orderId.length==0){
            console.log("========")
            delete req_params_record.orderId
				    this.getPaymentRemindRecordBy(this.req_params_record)
          }
        this.req_params_record = req_params_record
      },
      'req_params_record.userName':function(){
        var req_params_record =  this.req_params_record
          if(req_params_record.userName.length==0){
            delete req_params_record.userName
          }
          console.log(req_params_record)
        this.req_params_record = req_params_record
      },
      'req_params_record.starTime':function(){
        var req_params_record =  this.req_params_record
          if(req_params_record.starTime.length==0){
            delete req_params_record.starTime
          }
          console.log(req_params_record)
        this.req_params_record = req_params_record
      },
      'req_params_record.endTime':function(){
        var req_params_record =  this.req_params_record
          if(req_params_record.endTime.length==0){
            delete req_params_record.endTime
          }
          console.log(req_params_record)
        this.req_params_record = req_params_record
      },




      
      
      },
    
    async mounted(){
      this.getPageData()
      var params = {
        loopTimes:25,
        period:3600,
        shopId:this.shopId
      }
      // this.getPayRemindEchart(params)
      // this.setEchartOption()
      this.req_params_record.shopId = this.shopId
      // this.getPaymentRemindRecordList()
      this.getPaymentRemindRecordBy(this.req_params_record)
      // await this.getRemindSendCount(this.shopId)
    },
    methods:{

      ...mapActions('remind',[
				'getPaymentRemindRecordList',
        // 'getPayRemindEchart',

			]),

        getPaymentRemindRecordBy(params){
          var noteType = []
          noteType.push(this.$t('remind.shipReminder'))
          noteType.push(this.$t('remind.paymentRemind'))
          noteType.push(this.$t('remind.signRemind'))
          var deliveryResults = []
          deliveryResults.push(this.$t('remind.acceptFail'))
          deliveryResults.push(this.$t('remind.acceptSuccess'))
          deliveryResults.push(this.$t('remind.sending'))
          deliveryResults.push(this.$t('remind.acceptOutTime'))
*
          api.getNoteRecordBy(params)
            .then(res=>{
                if (res.code =='ok') {
                  var RecordList = res.noteRecord
                    for(var index in res.noteRecord){
                      RecordList[index].noteType_ = noteType[RecordList[index].noteType-1]
                      RecordList[index].deliveryResults = deliveryResults[RecordList[index].status]
                    }
                    this.tableData = res.noteRecord
                    console.log(111111)
                    console.log(res)
                    this.recordTotal = res.total
                }
          })
        },
        // 测试
       async demo(){
        var arr = []
        console.log(arr[0])

        },
        sum(arr){
          return eval(arr.join("+"));
        },

        async setCountOption_(noteType){
          this.CountEchartOption.title.subtext = ''
          this.CountEchartOption.title.subtext =this.$t('remind.setCountOption_tip1')+this.loopTimesType+this.$t('remind.setCountOption_tip2')+this.sum(this.CountEchartOption.series[0].data)+this.$t('remind.setCountOption_tip3')+this.sum(this.CountEchartOption.series[1].data)+this.$t('remind.strip')
          if(noteType==2){
            this.CountEchartOption.title.subtext+=','+this.$t('remind.In')+this.paymentPeriodCountType+this.$t('remind.seccessPay')+this.sum(this.CountEchartOption.series[2].data)+this.$t('remind.order')
          }
          switch (noteType) {
            case 1:
              var chartDom = document.getElementById('echart_shipmentCount');
              var myChart = echarts.init(chartDom);
              this.CountEchartOption && myChart.setOption(this.CountEchartOption);
              break;
            case 2:
              var chartDom = document.getElementById('echart_paymentCount');
              var myChart = echarts.init(chartDom);
              this.CountEchartOption && myChart.setOption(this.CountEchartOption);
              break;
            case 3:
              var chartDom = document.getElementById('echart_signRemindCount');
              var myChart = echarts.init(chartDom);
              this.CountEchartOption && myChart.setOption(this.CountEchartOption);
              break;
            default:
              break;
          }
          this.ifSetCountOption = false
          console.log(this.CountEchartOption)
        },


        seti18n(){
          this.CountOption.title.text = this.$t('remind.latelySendAndSuccessCount')
          this.CountOption.legend.data = [this.$t('remind.sendMessageTotal'),this.$t('remind.sendSuccessCount'),this.$t('remind.successPayCount')]
          console.log(this.CountOption)
          this.CountOption.series[0].name = this.$t('remind.sendMessageTotal')
          this.CountOption.series[1].name = this.$t('remind.sendSuccessCount')

        },





        async setCountOption(noteType,confirm){
          this.seti18n()
          this.CountEchartOption = this.CountOption
          if(confirm){
            this.paymentPeriodCountType = '1hour'
            this.loopTimesType = '1day'
          }
          var params,params_
          // 1/7/30/180
          switch (this.loopTimesType) {
            case '1day':
              params = {
                loopTimes :23,
                noteType :noteType,
                period :3600,
                shopId:this.shopId,
                status:"ALL"
              }
              this.CountEchartOption.xAxis.name = 'hour'
              break;
            case '7day':
              params = {
                loopTimes :7*24,
                noteType :noteType,
                period :3600,
                shopId:this.shopId,
                status:"ALL"
              }
              this.CountEchartOption.xAxis.name = 'hour'
              break;
            case '30day':
                params = {
                  loopTimes :29,
                  noteType :noteType,
                  period :3600*24,
                  shopId:this.shopId,
                  status:"ALL"
                }
                this.CountEchartOption.xAxis.name = 'day'
              break;
            case '90day':
                params = {
                  loopTimes :89,
                  noteType :noteType,
                  period :3600*24,
                  shopId:this.shopId,
                  status:"ALL"
                }
                this.CountEchartOption.xAxis.name = 'day'
              break;
            case '180day':
                params = {
                  loopTimes :179,
                  noteType :noteType,
                  period :3600*24,
                  shopId:this.shopId,
                  status:"ALL"
                }
                this.CountEchartOption.xAxis.name = 'day'
              break;
            default:
              break;
          }
          // 1/6/12
          switch (this.paymentPeriodCountType) {
            case "1hour":
              params_ = {
                loopTimes :params.loopTimes,
                paymentPeriod :60*60,
                period :params.period,
                shopId:this.shopId,
              }
              break;
            case "6hour":
              params_ = {
                loopTimes :params.loopTimes,
                paymentPeriod :6*3600,
                period :params.period,
                shopId:this.shopId,
              }
              break;
              case "12hour":
              params_ = {
                loopTimes :params.loopTimes,
                paymentPeriod :12*3600,
                period :params.period,
                shopId:this.shopId,
              }
              break;
            default:
              break;
          }
          this.CountEchartOption.series.splice(2,1)
          var xarr = []
          for(var i=0 ;i<params.loopTimes+1;i++){
            xarr.push(i)
          }
          this.CountEchartOption.xAxis.data = xarr
          this.setSendCountOption(params,params_)
        },


          async setSendCountOption(params,params_){
            this.ifSetCountOption = true
            api.getRemindSendCount(params)
            .then(res=>{
              var statisticMap = res.statisticMap
              var yarr = []
              for(var index in statisticMap){
                yarr.push(statisticMap[index])
              }
              var yarr_ = this.correctArr(yarr)
              this.CountEchartOption.series[0].data = yarr_
              params.status = 'SUCCESS'
              api.getRemindSendCount(params)
              .then(res_=>{
                var statisticMap_ = res_.statisticMap
                var yarr1 = []
                for(var index_ in statisticMap_){
                  yarr1.push(statisticMap_[index_])
                }
                var yarr1_ = this.correctArr(yarr1)
                this.CountEchartOption.series[1].data = yarr1_
                if(params.noteType!=2){
                  this.setCountOption_(params.noteType)
                }else{
                  this.getSuccessPayCount(params_,params.noteType)
                }
              })
              })
          },

          async getSuccessPayCount(params,noteType){
            api.getSuccessPayCount(params)
            .then(res=>{
              var statisticMap = res.statisticMap
              var yarr = []
              for(var index in statisticMap){
                yarr.push(statisticMap[index])
              }
              var yarr_ = this.correctArr(yarr)
              var json = {    
                name: '成功支付数',
                type: 'line',
                color:'#F56C6C',
                smooth: true,
                data: yarr_
              }
              json.name = this.$t('remind.successPayCount')
              this.CountEchartOption.series.push(json)
              this.setCountOption_(noteType)
            })

          },









        correctArr(arr){
          arr.unshift(arr[arr.length-1])
          arr.splice(-1,1)
          return arr
        },
        sum(arr){
          return eval(arr.join("+"));
        },










        getCodSwitch(){
          api.getCodSwitch({
            shopId:this.shopId
          })
          .then(res=>{
              if (res.code =='ok') {
                  this.codSwitch = res.codSwitch==0||res.codSwitch==null?false:true
              }
          })
        },
        
        setCodSwitch(){
          api.setCodSwitch({
            codSwitch :this.codSwitch?1:0,
            shopId :this.shopId
          }).then(res=>{
            console.log(res)
          })
        },


        getPageData(){
        // 页面返回时显示原本的商店选择
          var that = this
          var queryData1 = this.shopList.filter(function(fp) {
            return fp.shopId == that.$route.params.shopId
          })
          var queryData2 = this.lazadashopinfo.filter(function(fp) {
            return fp.sellerId == that.$route.params.shopId
          })
          if(queryData1[0]==undefined&&queryData2[0]!=null){
            that.value_LAZADA = queryData2[0].sellerId
            that.shopId = queryData2[0].sellerId
          }else if(queryData1[0]!=null&&queryData2[0]==undefined){
            that.value_shopee = queryData1[0].shopId
            that.shopId = queryData1[0].shopId
          }else{
            this.value_shopee = this.shopList[0].shopId
            this.shopId = this.shopList[0].shopId
            // this.req_params_record.shopId = this.shopList[0].shopId
            }

          // api.getNoteRecords({
          //   pageNum:1,
          //   pageSize :15,
          //   shopId:231532
          // })
          //   .then(res => {
          //     console.log(res.noteRecords)
          //     this.tableData = res.noteRecords
          //     for(var index in this.tableData){
          //       this.tableData[index].noteType_ = test.noteType[this.tableData[index].noteType]
          //     }
          // })


        },



        handleSelect:function(key){
          this.activeIndex = key
        },


        // 短信通道开关
        open:function(noteType){
          var status = null
          if(noteType==2){
            status = this.paymentRemind?1:0
          }else if(noteType==1){
            status = this.shipmentRemind?1:0
          }else if(noteType==3){
            status = this.signRemind?1:0
          }else{

          }
          
          let params = {
            noteType:noteType,
            shopId:this.shopId,
            status:status,
            userId:this.userId,
          }
            api.openNoteChannel(params)
            .then(res => {
              console.log(res)
          })
        },




        // 跳转编辑模板页面并传参
        edit(res,noteType){
            this.template_name = res
            var that = this
            if(this.value_shopee!=""){
                var shopId = that.value_shopee
            }else if(this.value_LAZADA!=""){
                var shopId = that.value_LAZADA
            }
            this.$router.push({
              name:"remind_template",
              params:{
                template_name:this.template_name,
                noteType:noteType,
                shopId:shopId
              }
            })
          },



        async echart_(){
          //获取echart显示区域
          var chartsline= echarts.init(document.getElementById('echart_1'));
          var options = this.echart_option
          console.log(options)
      // 将options导入echart
          options && chartsline.setOption(options)

            options.xAxis.data = xarr
            options.series[0].data = yarr
            this.echart_option = options
        },















        handleClose(done) {
              if (this.loading) {
                return;
              }
              this.$confirm(this.$t('other.a2221'))
                .then(_ => {
                  this.loading = true;
                  this.timer = setTimeout(() => {
                    done();
                    // 动画关闭需要一定的时间
                    setTimeout(() => {
                      this.loading = false;
                    }, 400);
                  }, 2000);
                })
                .catch(_ => {});
            },

        cancelForm() {
          this.loading = false;
          this.dialog = false;
          clearTimeout(this.timer);
        },



			getValue(){
        var req_params_record = this.req_params_record
				req_params_record.startTime=this.time[0]
				req_params_record.endTime=this.time[1]
        // this.getPaymentRemindRecordBy(req_params_record)
			},


			getOrderSn(){
				this.getPaymentRemindRecordBy(this.req_params_record)
			},




			handleSizeChange(val) {
        console.log(val)
        this.req_params_record.pageSize = val
        this.getPaymentRemindRecordBy(this.req_params_record)
			 },


			handleCurrentChange(val) {
        console.log(val)
        this.req_params_record.pageNum = val
        this.getPaymentRemindRecordBy(this.req_params_record)       
			},











        //websock链接
        connectWebsocket(){
             const wsuri = "ws://47.57.9.89:8101/ws";
            this.websock = new WebSocket(wsuri);
            console.log(this.websock)
            this.websock.onmessage = this.websocketonmessage;
            this.websock.onopen = this.websocketonopen;
            this.websock.onerror = this.websocketonerror;
            this.websock.onclose = this.websocketclose;
    
        },
         websocketonopen(){ //连接建立之后执行send方法发送数据
           this.$message.success(this.$t('other.a371'))
            
          },
          websocketonerror(){//连接建立失败重连
            this.$message.success(this.$t('other.a372'))
          },
          websocketonmessage(e){ //数据接收
            const redata = JSON.parse(e.data);
            console.log('字符串',redata)
          },
          websocketsend(Data){//数据发送
            this.websock.send(Data);
          },
          websocketclose(e){  //关闭
            console.log('断开连接',e);
          },

      }
    }
    
    </script>
    <style lang="scss" scoped>
    @import "~@assets/scss/mixins";
    .remindWrapper{
          // @include main-right-content();
          .remind_header{
              height: 2rem;
              border-bottom: 1px solid #eeee;
              padding: 0.67rem 0;
    
              .merber{
                  margin-left:1.33rem
              }
          }


          .remind_mid , .seller_ctn , .remind_main{
            margin-top: 1.33rem;
          }


          .box-card{
            width: 250px;
          }
          .card_bottom{
            height: 240px;
          }
          .card_ctn{
            margin-top: 1.6rem;
          }
          .switch{
            display: flex;
            justify-content: center;
          }

          
          .block , .el_col_ctn{
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .remind_message{

            height: 4rem;
            display: flex;
            align-items: center;
            background: rgb(217, 236, 255);
            font-size: 14px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
          }
          .center{
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .margin{
            margin-top: 1.33rem;
          }
          .word{
            word-wrap:break-word;
            
          }
          	.block{
              display: flex;
              align-items: center;
              margin-bottom: 1.33rem;
            }
            .page{
              float: right;
              position: fixed;
              bottom: 0;
              left: 2rem;
              right: 0;
              height: 2.66rem;
              line-height: 2.66rem;
              background-color: #fff;
              text-align:right;             
            }
            .left{
              float:left
            }
            .right{
              float: right;
            }
          .red{
            color:#F56C6C
          }
          .info{
            color:#606266
          }
    }
    
    </style>